export default __webpack_public_path__ + "static/media/some-data-missing.caf49ebc.svg";